import React from "react";

class BoxToggle extends React.Component {
  constructor() {
    super();
    this.state = {
      isToggleOn: false,
    };

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    this.setState((state) => ({
      isToggleOn: !state.isToggleOn,
    }));
  }

  render() {
    return (
      <div>
        {this.state.isToggleOn ? (
          <div style={{ paddingLeft: this.props.paddLeft && "20px" }}>
            <div className="underline">
              <span className="hover" onClick={this.handleClick}>
                {this.props.title} -
              </span>
            </div>
            {this.props.text_opened}
            {this.props.paddBot && (
              <div style={{ paddingBottom: "20px" }}></div>
            )}
          </div>
        ) : (
          <div style={{ paddingLeft: this.props.paddLeft && "20px" }}>
            <div className="underline">
              <span className="hover" onClick={this.handleClick}>
                {this.props.title} +
              </span>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default BoxToggle;
